import { atom } from 'jotai'

export const selectedStateCode = atom<string | undefined>(undefined)
